<template>
  <div>
    <div class="spinner-grow" role="status" v-if="loadingData === true"></div>
    <div class="col-12">
      <p-button
        class="btn btn-info m-2"
        type="info"
        @click.native.prevent="goBack"
      >
        Back to Institutions
      </p-button>
      <!-- <router-link class="btn btn-info m-2" :to="`/dashboard/institutions`"> Back to Institutions </router-link> -->
      <button
        class="btn btn-info m-2"
        @click="doDisable"
        v-if="institution.disabled === false"
      >
        Disable Institution
      </button>
      <button
        class="btn btn-info m-2"
        @click="doEnable"
        v-if="institution.disabled === true"
      >
        Enable Institution
      </button>
    </div>

    <card class="card">
      <div>
        <form @submit.prevent>
          <div class="row">
            <div class="col-md-6">
              <fg-input
                type="text"
                label="Institution Name"
                placeholder="Institution Name"
                v-model="institution.institutionName"
              >
              </fg-input>
            </div>
            <div class="col-md-6">
              <fg-input
                type="text"
                label="Company Name"
                placeholder="Company Name"
                v-model="institution.companyName"
              >
              </fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <label>Institution Type</label>
              <select
                class="form-control"
                v-model="institution.institutionType"
                placeholder="Select an institution Type"
              >
                <option value="">Select an institution Type</option>
                <option value="bank">Bank</option>
                <option value="super-agent">Super Agent</option>
              </select>
            </div>

            <div class="col-md-6">
              <fg-input
                type="text"
                label="RC Number"
                placeholder="RC Number"
                v-model="institution.regNumber"
              >
              </fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <fg-input
                type="text"
                label="Email"
                placeholder="Email"
                v-model="institution.email"
              >
              </fg-input>
            </div>
            <div class="col-md-6">
              <fg-input
                type="text"
                label="Address"
                placeholder="Address"
                v-model="institution.address"
              >
              </fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <fg-input
                type="text"
                label="Phone Number"
                placeholder="Phone Number"
                v-model="institution.phoneNumber"
                maxlength="11"
                @input="
                  institution.phoneNumber = institution.phoneNumber.replace(
                    /\D/g,
                    '',
                  )
                "
              >
              </fg-input>
            </div>

            <div class="col-md-6">
              <fg-input
                type="text"
                label="Wallet Id"
                placeholder="WalletId"
                :disabled="true"
                v-model="institution.walletId"
              >
              </fg-input>
            </div>
          </div>

          <!-- <div class="row">
						<div class="col-md-4">
							<label>Country</label>
							<select
								class="form-control op-border"
								id="rate-type"
								v-model="institution.country"
								required
								@change="getStates()"
							>
								<option value="">country</option>
								<option
									v-for="(ct, index) in utils.countries"
									:key="index"
									:value="ct.code"
								>
									{{ ct.name }}
								</option>
							</select>
						</div>

						<div class="col-md-4">
							<label>State</label>
							<select
								class="form-control op-border"
								id="rate-type"
								v-model="institution.state"
								required
								@change="fetchLgas()"
							>
								<option value="">State</option>
								<option v-for="st in utils.allStates" :key="st" :value="st">
									{{ st }}
								</option>
							</select>
						</div>

						<div class="col-md-4">
							<label>Local Government</label>
							<select
								class="form-control op-border"
								id="rate-type"
								v-model="institution.localGovernment"
								required
							>
								<option value="">Select Local Government</option>
								<option v-for="lg in utils.lgas" :key="lg.id" :value="lg.name">
									{{ lg.name }}
								</option>
							</select>
							<span v-if="utils.lgaLoading"> Fetching Lga's </span>
						</div>
					</div> -->

          <div class="text-center">
            <p-button
              type="info"
              round
              @click.native.prevent="submit"
              :disabled="loading"
            >
              <div class="spinner-grow" role="status" v-if="loading"></div>
              Update Institution
            </p-button>
          </div>
          <div class="clearfix"></div>
        </form>
      </div>
    </card>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import axios from "../store/axios";
export default {
  data() {
    return {
      loading: false,
      loadingData: false,
      institution: {
        institutionName: "",
        reqNumber: "",
        companyName: "",
        email: "",
        address: "",
        phoneNumber: "",
        country: "",
        state: "",
        localGovernment: "",
        institutionType: "",
      },
    };
  },
  computed: {
    ...mapState(["auth", "loading", "utils"]),
  },
  methods: {
    ...mapActions([
      "editInstitution",
      // 'getStates',
      // 'getLgas',
      "getCountries",
      "setLoading",
      "disableInstitution",
      "enableInstitution",
    ]),
    goBack() {
      this.$router.push("/dashboard/institutions");
    },
    submit() {
      this.loading = true;
      this.$confirm("Edit Institution Details?").then(() => {
        const data = { id: this.$route.params.id, ...this.institution };
        this.editInstitution(data);
        this.loading = false;
      });
    },
    // fetchLgas() {
    // 	this.institution.lga = '';
    // 	this.getLgas(this.institution.state);
    // },
    doDisable() {
      this.$confirm("Disable Institution! Are you sure?").then(() => {
        this.disableInstitution({ id: this.$route.params.id });

        this.institution.disabled = true;
        setTimeout(() => {
          this.getInstitution();
        }, 500);
      });
    },
    doEnable() {
      this.$confirm("Enable Institution?").then(() => {
        this.enableInstitution({ id: this.$route.params.id });
        this.institution.disabled = false;
        setTimeout(() => {
          this.getInstitution();
        }, 500);
      });
    },

    async getInstitution() {
      try {
        this.setLoading(true);
        this.loadingData = true;

        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/institution/${this.$route.params.id}`,
        );
        const { institution } = res.data;
        this.institution = institution;

        this.getLgas(this.institution.state);
      } catch (error) {
        console.error(error);
        this.setNotification({
          type: "danger",
          message: error.response.data.message,
        });
      } finally {
        this.setLoading(false);
        this.loadingData = false;
      }
    },
  },
  async mounted() {
    // this.getCountries();
    // this.getStates();
    await this.getInstitution();
  },
};
</script>
<style></style>
